import {Detour} from '../apis/api-goodtoknow.ts';
import {Place} from '../apis/api-places.ts';
import {
  Accommodation,
  Bicycle,
  Slowup,
  Station,
  Swisspark,
} from '../apis/api-poi.ts';
import {Sightseeing} from '../apis/api-sightseeings.ts';
import {Travelreport} from '../apis/api-travelreports.ts';
import {getLanguageCode} from '../i18n.ts';
import type {POIModalOptions} from '../stores/store-main.ts';
import {disableKvp$, modal$} from '../stores/store-main.ts';
import {
  landUrlFragment,
  overlayDirectUrlFragment,
} from '../urlHandling/urlParams.ts';
import {isPOIOverlay} from '../helpers/constants.ts';
import {
  createSightseeingPlaceUrl,
  createPointOfInterestUrl,
} from '../urlHandling/urlCreate.ts';

export function registerModalObserver() {
  modal$.subscribe((options) => {
    if (isPOIOverlay(options)) {
      options = <POIModalOptions>options;
      const lang = getLanguageCode();
      let layer;
      if (options.data instanceof Place)
        layer = overlayDirectUrlFragment.place[lang];
      else if (options.data instanceof Sightseeing)
        layer = overlayDirectUrlFragment.sightseeing[lang];
      else if (options.data instanceof Accommodation)
        layer = overlayDirectUrlFragment.accommodation[lang];
      else if (options.data instanceof Detour)
        layer = overlayDirectUrlFragment.detour[lang];
      else if (options.data instanceof Swisspark)
        layer = overlayDirectUrlFragment.swisspark[lang];
      // else if (options.data instanceof WildlifeArea) layer = poiLayers.wildlifearea[lang];
      // else if (options.data instanceof WildlifeRoute) layer = poiLayers.wildliferoute[lang];
      // else if (options.data instanceof AlpguardDog) layer = poiLayers.alpguarddog[lang];
      else if (options.data instanceof Station)
        layer = overlayDirectUrlFragment.station[lang];
      else if (options.data instanceof Slowup)
        layer = overlayDirectUrlFragment.slowup[lang];
      else if (options.data instanceof Bicycle)
        layer = overlayDirectUrlFragment[options.data.type][lang];
      else if (
        options.type === 'travelreport' &&
        options.data.travelreport instanceof Travelreport
      )
        layer = overlayDirectUrlFragment.travelreport[lang];
      if (layer) {
        disableKvp$.next(true);
        if (options.type === 'sightseeing' || options.type === 'place') {
          window.history.replaceState(
            {},
            '',
            createSightseeingPlaceUrl(
              options.data.title,
              lang,
              layer,
              options.data.id,
            ),
          );
        } else if (options.type === 'travelreport') {
          if (options.data.segment) {
            const land = landUrlFragment[options.data.segment.land][lang];
            window.history.replaceState(
              {},
              '',
              `/${lang}/${land}/${layer}-${options.data.travelreport.id}`,
            );
          }
        } else {
          window.history.replaceState(
            {},
            '',
            createPointOfInterestUrl(lang, layer, options.data.id),
          );
        }
      }
    }
  });
}
